import React, { createContext, useState, useEffect } from "react";

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    firstMessage: "",
    callPrompt: "",
    voiceId: "",
    language: "en",
    modelId: "eleven_turbo_v2_5",
    agentId: "",
  });

  // Load from localStorage when app starts
  useEffect(() => {
    const savedConfig = JSON.parse(localStorage.getItem("callConfig"));
    if (savedConfig) {
      setConfig(prev => ({ ...prev, ...savedConfig }));
    }
  }, []);

  // Automatically save when config changes
  useEffect(() => {
    localStorage.setItem("callConfig", JSON.stringify(config));
  }, [config]);

  return (
    <ConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};
